<template>
  <div>
    <div class="card" style="padding: 5px 10px 5px; border-radius: 10px">
      <div class="card-header">
        <div class="row">
          <div class="col-md-10">
            <strong style="font-size:20px">Información de los gastos</strong><br />
            <span style="color: darkgray"
              >Listado de todos los gastos que corresponden a estas fechas</span
            > <br>
            <span style="color:darkgray">Resumen de los gatos: <span style="color:red;">{{ resumenGastos }}</span> </span>
          </div>
          <!-- <div class="col-md-2">
            <button
              class="btn pull-right"
              style="border-radius: 8px"
              @click="abrirModal()"
            >
              <i class="fa fa-arrow-right"></i>
            </button>
          </div> -->
        </div>
      </div>
      <hr>
      <div class="card-content" style="max-height: 400px; overflow: scroll; overflow-x: hidden;">
        <div class="row">
          <div
            class="col-md-12"
            v-for="gasto in informacionGastos"
            :key="gasto.id"
          >
            <div class="card" style="border:1px darkgray solid;">
              <div class="card-content">
                <div class="row">
                  <div class="col-md-3">
                    <strong style="color:red;">{{ gasto.valor }}</strong> <br />
                    <small style="color: grey">MONTO</small>
                  </div>
                  <div class="col-md-2">
                    <!-- <i class="fa fa-arrow-up" style="color: green"></i> -->
                    <strong> {{ gasto.fecha != null ? gasto.fecha  : 'N/A' }}</strong> <br />
                    <small style="color: grey">FECHA</small>
                  </div>
                  <div class="col-md-2">
                    <!-- <i class="fa fa-arrow-up" style="color: green"></i> -->
                    <strong> {{ gasto.usuario != null ? gasto.usuario : 'N/A' }}</strong> <br />
                    <small style="color: grey">USUARIO</small>
                  </div>
                  <div class="col-md-2">
                    <!-- <i class="fa fa-arrow-up" style="color: green"></i> -->
                    <strong> {{ gasto.categoria }}</strong> <br />
                    <small style="color: grey">CATEGORIA</small>
                  </div>
                  <div class="col-md-3">
                    <!-- <i class="fa fa-arrow-up" style="color: green"></i> -->
                    <strong> {{ gasto.concepto }}</strong> <br />
                    <small style="color: grey">COMENTARIO</small>
                  </div>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
import nomicard from "src/components/aDashboard/nomina/cardnomina.vue";
import axiosInstance from "src/global-services/axiosInstance";
import formatearPesosColombianos from "../../../global-services/formatear-pesos";
export default {
  data() {
    return {
      informacionGastos: [],
      resumenGastos: 0,
    };
  },
  methods: {
    getGastos: async function (fechaInicial, fechaFinal) {
      try {
        const BASE_URL = `api/gastos-dashboard/${fechaInicial}/${fechaFinal}`;
        const response = await axiosInstance.get(BASE_URL);
        if (response.data.status == true) {
          const data = response.data.data;
          let resumen = 0;
          let dataFormated = data.map((element) => {
            resumen = resumen + element.valor;
            return {
              usuario: element.usuario,
              valor: formatearPesosColombianos(element.valor),
              fecha: element.fecha,
              concepto: element.comentario,
              categoria: element.categoria,
            };
          });
          this.resumenGastos = formatearPesosColombianos(resumen);
          this.informacionGastos = dataFormated;
        }
      } catch (error) {
      } finally {
      }
    },
  },
  components: {
    nomicard,
  },
};
</script>


// WEBPACK FOOTER //
// src/components/aDashboard/nomina/informacionGastos.vue